import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { i18nTranslate, application, isB2BUser } from 'src/utils'
import { Button, Row, Col } from 'react-bootstrap'
import { isCrossMarketAllowed } from 'src/utils/marketUtils'
import {
  addressContainer,
  accountsAddressContainer,
  customerContainer,
} from 'src/models'
import { countriesWithoutPostalCodes } from 'src/static/geography'
import './styles.scss'

@observer
class AddressDetail extends React.Component {
  @observable toggleRemoveConfirmation = false

  ADDRESS_DETAILS = 'ADDRESS_DETAILS'
  DEFAULT_VIEW = 'DEFAULT_VIEW'
  CONFIRMATION_VIEW = 'CONFIRMATION_VIEW'

  toggleRemoveAddress = () => {
    this.toggleRemoveConfirmation = !this.toggleRemoveConfirmation

    if (this.toggleRemoveConfirmation) {
      setTimeout(() => {
        const removeAddressText = document.querySelector(
          '.confirm-remove-view .text-danger'
        )
        if (removeAddressText) {
          removeAddressText.focus()
        }
      }, 0)
    }
  }

  handleRemove = async () => {
    if (isB2BUser() /*|| isB2BAdmin()*/) {
      await accountsAddressContainer.deleteAccountAddress(
        this.props.addressInfo
      )
    } else {
      await addressContainer.deleteProfileAddress(this.props.addressInfo)
    }
    this.toggleRemoveAddress()
  }

  getDataModal(dataKey) {
    switch (dataKey) {
      case this.ADDRESS_DETAILS:
        return {
          addressInfo: this.props?.addressInfo,
          isDefault: this.props?.addressInfo.isDefault || false,
          defaultAddressText: i18nTranslate(
            'addressBook.defaultTitle',
            'Default Address'
          ),
        }
      case this.DEFAULT_VIEW:
        return {
          removeButtonText: i18nTranslate('address.removeButton', 'Remove'),
        }
      case this.CONFIRMATION_VIEW:
        return {
          removeAddressText: `${i18nTranslate(
            'address.remove',
            'Remove Address'
          )}?`,
          yesText: i18nTranslate('address.yesLabel', 'Yes'),
          noText: i18nTranslate('address.noLabel', 'No'),
        }

      default:
        return {}
    }
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.DEFAULT_VIEW:
      case this.CONFIRMATION_VIEW:
        return {
          size: application.isMobile ? 'md' : 'lg',
        }

      default:
        return {}
    }
  }

  renderConfirmationView = () => {
    const data = this.getDataModal(this.CONFIRMATION_VIEW)
    const styles = this.getStyleGuides(this.CONFIRMATION_VIEW)
    return (
      <Row
        noGutters
        className="confirm-remove-view mt-3 d-flex flex-wrap align-items-center justify-content-md-start justify-content-between">
        <span className="text-danger" tabIndex="0">
          {data?.removeAddressText}
        </span>
        <Button
          className="confirm-button p-0 mx-0 mx-md-2 my-2 my-md-0"
          onClick={this.handleRemove}
          variant="primary"
          size={styles?.size}
          data-testid="qa-remove-yes">
          {data?.yesText}
        </Button>
        <Button
          className="confirm-remove-button p-0 mx-0 mx-md-2 my-2 my-md-0"
          onClick={this.toggleRemoveAddress}
          variant="outline-primary"
          size={styles?.size}
          data-testid="qa-remove-no">
          {data?.noText}
        </Button>
      </Row>
    )
  }

  renderDefaultView = () => {
    const data = this.getDataModal(this.DEFAULT_VIEW)
    const styles = this.getStyleGuides(this.DEFAULT_VIEW)
    return (
      <Row
        noGutters
        className="d-flex flex-row align-items-center justify-content-between mt-3">
        {!isB2BUser() /*&& !isB2BAdmin()*/ && (
          <Button
            className="address-remove-button p-0 px-3 d-flex align-items-center justify-content-center"
            variant="outline-primary"
            size={styles?.size}
            onClick={this.toggleRemoveAddress}
            data-testid="qa-remove-button">
            {data?.removeButtonText}
          </Button>
        )}
      </Row>
    )
  }

  renderButton = () => {
    const buttonView = this.toggleRemoveConfirmation
      ? this.renderConfirmationView()
      : this.renderDefaultView()

    return buttonView
  }

  render() {
    const data = this.getDataModal(this.ADDRESS_DETAILS)
    let county = data?.addressInfo?.county || ''
    const isCrossMarketAllowedFlag =
      customerContainer.isCrossMarketAllowed() || false

    const state = data?.addressInfo?.state

    return (
      <React.Fragment>
        <div className={`${isCrossMarketAllowedFlag ? '' : 'd-none'}`}>
          <Row
            noGutters
            className="flex-row text-capitalize"
            style={{ width: '50%' }}>
            <Row noGutters className="w-100">
              {data?.isDefault === true && (
                <span className="default-address-title paragraph-m">
                  {data?.defaultAddressText}
                </span>
              )}
            </Row>
            <Col className="d-flex flex-column p-0">
              <span className="d-flex flex-wrap paragraph-l-bold mb-2">
                <span className="mr-1">
                  {data?.addressInfo?.firstName || ''}
                </span>
                <span>{data?.addressInfo?.lastName || ''}</span>
              </span>
              <span
                className="paragraph-m address-length"
                data-testid="qa-street">
                {data?.addressInfo?.addressLine1 || ''}
              </span>
              <span
                className="paragraph-m address-length"
                data-testid="qa-street">
                {data?.addressInfo?.addressLine2 || ''}
              </span>
              <span
                className="paragraph-m address-length"
                data-testid="qa-region">
                {data?.addressInfo?.city || ''}
              </span>
              {county && (
                <span
                  className="paragraph-m address-length"
                  data-testid="qa-county">
                  {county}
                </span>
              )}
              <span
                className="paragraph-m address-length"
                data-testid="qa-locality">
                {state || ''}
              </span>
              {!countriesWithoutPostalCodes.includes(
                data?.addressInfo?.country || ''
              ) && (
                <span className="paragraph-m" data-testid="qa-zip">
                  {data?.addressInfo?.zip || ''}
                </span>
              )}
              <span
                className="paragraph-m address-length"
                data-testid="qa-country">
                {data?.addressInfo?.country || ''}
              </span>
            </Col>
          </Row>
          {this.renderButton()}
        </div>
      </React.Fragment>
    )
  }
}

export { AddressDetail }
export default AddressDetail
